<template>
  <material-content :type="type" :projection="projection" :title="title" />
</template>

<script>
import { MATERIALS_TYPES } from '@/enums/MaterialsTypes';
import MaterialContent from './UIComponents/MaterialContent.vue';

export default {
  components: {
    MaterialContent,
  },
  data() {
    return {
      type: MATERIALS_TYPES.computer.value,
      projection: 'materialComputerSummary',
      title: 'Liste des postes de travail',
    };
  },
};
</script>
